var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisitReportCylinderchange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06641 9.52809L8.78274 10.2211L10.4927 8.53516",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9051 5.35262L17.8656 5.48686C18.1204 5.52246 18.3464 5.66178 18.4938 5.87417C18.6413 6.08656 18.6983 6.35462 18.6521 6.61939L17.6075 12.6092C17.5614 12.8739 17.4159 13.1137 17.2031 13.2757C16.9903 13.4378 16.7277 13.5088 16.4729 13.4732L13.7368 13.0908M11.7914 6.51731L11.9284 5.67972C11.9745 5.41496 12.12 5.17518 12.3328 5.01314C12.5456 4.8511 12.8082 4.78006 13.063 4.81566L14.0235 4.9499",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84961 8.59766L3.84324 9.50785L4.83686 10.418M4.83686 8.59766L2.84961 10.418",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0476 7.97478L14.887 7.72655M16.7587 9.78484L14.5982 9.44352M16.493 11.5638L14.3093 11.2639M16.9043 5.35193C16.9505 5.08717 16.8936 4.8191 16.7461 4.60671C16.5986 4.39432 16.3726 4.255 16.1179 4.2194L15.1573 4.08516C14.9026 4.04956 14.6399 4.12059 14.4271 4.28263C14.2144 4.44468 14.0689 4.68445 14.0227 4.94922C13.9765 5.21398 14.0335 5.48205 14.1809 5.69444C14.3284 5.90683 14.5544 6.04615 14.8092 6.08175L15.7697 6.21599C16.0244 6.25159 16.2871 6.18056 16.4999 6.01852C16.7127 5.85647 16.8581 5.6167 16.9043 5.35193Z",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9299 15.7124C11.9299 15.7124 9.89409 16.8342 8.4522 16.9536C7.17123 17.0597 6.34649 17.0038 5.1247 16.6433C4.09557 16.3397 3.56873 16.0041 2.70996 15.4125C1.92267 14.8702 1 13.7266 1 13.7266M2.15538 14.0679L1 13.7266V14.854",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8204 2.07965L12.9128 3.01053L11.9192 2.93813M12.9128 3.01053C12.9128 3.01053 11.465 1.74554 10.2901 1.35564C9.35727 1.04609 8.76449 0.962435 7.77135 1.01431C6.40634 1.08562 4.47852 2.07965 4.47852 2.07965",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0391 7.52008L13.4088 7.9338L14.3677 7.23047",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7617 9.24664L13.1314 9.66036L14.0904 8.95703",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4844 11.0474L12.8541 11.4611L13.8131 10.7578",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50586 12.4105V6.81061H1.50648C1.50648 5.90563 2.541 5.17188 3.81693 5.17188C5.09286 5.17188 6.12738 5.90563 6.12738 6.81061V14.1305C6.12738 14.3114 5.92072 14.4585 5.66504 14.4585H3.81662",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeMiterlimit: 133.33,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8014 5.17389V3.53516M3.8014 3.53516H3.03125M3.8014 3.53516H4.57155",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeMiterlimit: 133.33,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88867 12.4105V6.81061H6.88929C6.88929 5.90563 7.92381 5.17188 9.19974 5.17188C10.4757 5.17188 11.5102 5.90563 11.5102 6.81061V14.1305C11.5102 14.3114 11.3035 14.4585 11.0479 14.4585H9.19943",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeMiterlimit: 133.33,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5098 12.4105V6.81061H11.5091C11.5091 5.90563 10.4746 5.17188 9.1987 5.17188C7.92277 5.17188 6.88825 5.90563 6.88825 6.81061V14.1305C6.88825 14.3114 7.0949 14.4585 7.35058 14.4585H9.19901",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeMiterlimit: 133.33,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27601 5.17389V3.53516M9.27601 3.53516H8.50586M9.27601 3.53516H10.0462",
    stroke: "#3D3D3D",
    strokeWidth: 0.5,
    strokeMiterlimit: 133.33,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitReportCylinderchange);
export default __webpack_public_path__ + "static/media/Visit Report Cylinder change.fb3772ec177ef70efef7f5bc70cb73a6.svg";
export { ForwardRef as ReactComponent };